// generated by genversion
export var version = '4.3.7';
//# sourceMappingURL=version.js.map